var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"ruler","cursor":"move"}},[_c('rect',{attrs:{"x":_vm.start_x,"y":"0","width":_vm.width,"height":_vm.height,"fill":"#ff0","opacity":"0.8"}}),_vm._l((_vm.ruler_lines),function(y){return _c('line',{key:y,attrs:{"x1":_vm.start_x,"y1":y,"x2":_vm.start_x+_vm.width,"y2":y,"stroke":"#666"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }